module.exports = __webpack_public_path__ + "static/body-bg-89c30fdc799c7ec9d1c5056a822c475a.jpg";